<p-button
  (click)="action.emit($event)"
  class="add-btn {{size}} "
  [loading]="loading"
  [disabled]="disable"
  [size]="size"
  icon="{{icon}}"
  [label]="title | translate"
  [style]="{ width: width}"
>
</p-button>
